import { asMoney, asString } from "../../../../Bfs.Web.Data.Service.Contracts/Shared.fs.js";
import { sortByDescending, map, isEmpty, singleton as singleton_1, sortBy, ofArray } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { desktopDataTable, mobileDataList } from "../Shared/DataList.fs.js";
import { compare } from "../../../fable_modules/fable-library-js.4.19.0/Date.js";
import { bfsCard, bfsCardCollapsable } from "../Shared/Card.fs.js";
import { spinner } from "../../../../Bfs.Web.Portale/ViewParts.fs.js";
import { singleton, append, delay } from "../../../fable_modules/fable-library-js.4.19.0/Seq.js";
import * as react from "react";
import { DashboardPage } from "../DashBoardPage.fs.js";
import { HTMLAttr } from "../../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { comparePrimitives } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";

export const columnMapping = ofArray([["RechnungsNr", (row) => row.RechnungsNrExtern], ["Klient/Patient", (row_1) => row_1.KlientPatient], ["Leistungsgrundlage", (row_2) => row_2.LeistungsGrundlage], ["Fälligkeitsdatum", (row_3) => asString(row_3.Faelligkeitsdatum)], ["Rechnungsbetrag", (row_4) => asMoney(row_4.Rechnungsbetrag)]]);

export function mobileTable(data) {
    return mobileDataList("Hier werden Sie zukünftig alle Ihre anstehenden Zahlungen sehen.", columnMapping, sortBy((row) => row.Faelligkeitsdatum, data, {
        Compare: compare,
    }));
}

export function desktopTable(data) {
    return desktopDataTable("Hier werden Sie zukünftig alle Ihre anstehenden Zahlungen sehen.", columnMapping, sortBy((row) => row.Faelligkeitsdatum, data, {
        Compare: compare,
    }));
}

function SendungList(sendungsNr, faelligkeitsdatum, summe, data) {
    return bfsCardCollapsable([`Sendung ${sendungsNr}, Fälligkeiten ab: ${asString(faelligkeitsdatum)}, Auszahlungsbetrag: ${asMoney(summe)}`, ofArray([mobileTable(data), desktopTable(data)]), false]);
}

export function view(model, _arg, navigateTo) {
    if (model.Loading) {
        return spinner;
    }
    else {
        return Array.from(delay(() => {
            let children_2, props_10, children_10, children_4, s_1;
            return append(singleton(bfsCard(singleton_1((children_2 = [react.createElement("i", {
                className: "fas fa-angle-left mr-2",
            }), "Zurück zum Dashboard"], react.createElement("a", {
                onClick: (_arg_1) => {
                    navigateTo(new DashboardPage());
                },
            }, ...children_2))), singleton_1((props_10 = [["style", {
                margin: "0.8rem",
            }], new HTMLAttr(65, ["pb-4"])], (children_10 = [(children_4 = [(s_1 = "Bitte beachten Sie, dass dies der voraussichtliche Zahlbetrag ist. Verrechnungen, Vorzugsgebühren o.ä. können ggf. noch in Abzug gebracht werden. Unter ", s_1)], react.createElement("span", {}, ...children_4)), react.createElement("a", {
                href: "/#verrechnungen",
            }, "Verrechnungen"), react.createElement("span", {}, " können Sie diese hier im Portal prüfen.")], react.createElement("div", keyValueList(props_10, 1), ...children_10)))))), delay(() => (isEmpty(model.Data) ? singleton_1(bfsCard(undefined, singleton_1("Wir freuen uns auf Ihre erste Sendung!"))) : map((data) => SendungList(data.SendungNr, data.Faelligkeit, data.Summe, data.Rechnungen), sortByDescending((x) => x.SendungNr, model.Data, {
                Compare: comparePrimitives,
            })))));
        }));
    }
}

//# sourceMappingURL=View.fs.js.map
